/** @format */

import React from 'react';
import 'loggly-jslogger';

const Tracker = (type, stack, message, userId) => {
    // LogglyTracking is globally defined by loggly-jslogger;
    const Client = new LogglyTracker(); // eslint-disable-line
    Client.push({
        logglyKey: 'bcb7b1fe-3685-4ca7-a649-239f3f6e9de4',
        tag: 'frontier-js-error-log'
    });
    const data = {
        errorType: type,
        stackTrace: stack,
        messageText: message,
        href: window.location.href,
        userAgent: window.navigator.userAgent,
        appVersion: window.navigator.appVersion
    };

    if (!isNaN(parseFloat(userId)) && isFinite(userId)) {
        data.userId = userId;
    }

    Client.push(data);
};

const ThrownErrorHandler = e => {
    console.log(e); // eslint-disable-line
    Tracker('Thrown Error', e.stack, e.message, window.user_id);
    return true;
};

const WindowErrorHandler = (msg, url, lineNo, columnNo, error) => {
    console.log(error); // eslint-disable-line
    Tracker('Window Error', JSON.stringify(error), msg, window.user_id);
    return true;
};

export {WindowErrorHandler, ThrownErrorHandler, Tracker};
